// Core
import { Component } from '@angular/core';

// Font Awesome
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faPhone, faEnvelope, faComments } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-index-contact-section',
    imports: [FontAwesomeModule],
    templateUrl: './index-contact-section.html',
    styleUrl: './index-contact-section.scss',
})

export class IndexContactSection {
    faPhone = faPhone;
    faEnvelope = faEnvelope;
    faComments = faComments;
}
